module.exports = __webpack_public_path__ + "assets/img/39@3x.f0c996d9.png";